import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useState } from "react";
import { Alert, Button, Modal, Row } from "react-bootstrap";
import { convertMinutesToHour } from "../../utils/numberUtil";
import { Flex } from "antd";
import "./DurationModal.css";
import classNames from "classnames";

type Props = {
  slots: string[];
  onClose: () => void;
  onSubmit: (duration: number) => void;
};

export default function DurationModal({
  slots,
  onClose,
  onSubmit,
}: Props) {
  const [selectedDuration, setSelectedDuration] = useState<number>();
  const [durationOptions, setDurationOptions] = useState<number[]>();

  const getDurationOptions = useCallback(() => {
    const options: number[] = [];
    const maxCount = Math.min(slots.length, 4);
    for (let i = 1; i <= maxCount; i++) {
      options.push(i * 30);
    }
    setDurationOptions(options);
  }, [slots]);

  useEffect(() => {
    getDurationOptions();
  }, [getDurationOptions]);

  const handleSelectDuration = useCallback(
    (duration: number) => (e: React.MouseEvent) => {
      e.preventDefault();

      if (duration === selectedDuration) setSelectedDuration(undefined);
      else setSelectedDuration(duration);
    },
    [selectedDuration]
  );

  const handleSubmit = useCallback(() => {
    onSubmit(selectedDuration!);
  }, [selectedDuration, onSubmit]);

  if ((durationOptions || []).length === 0)
    return (
      <Alert variant="info" className="py-2">
        <FontAwesomeIcon icon={faInfoCircle} />
        <span className="ms-2">Nessun orario disponibile</span>
      </Alert>
    );

  return (
    <>
      <Modal.Body>
        <Row>
          <h5>Scegli tra le seguenti opzioni:</h5>
        </Row>
        <Flex align="center" justify="space-around" style={{ padding: 12 }}>
          {(durationOptions || []).map((duration, i) => (
            <button
              key={i}
              onClick={handleSelectDuration(duration)}
              className={classNames("duration-button", {
                selected: (selectedDuration || 0) === duration,
              })}
            >
              <span className="fw-semibold">
                {convertMinutesToHour(duration)}
              </span>
            </button>
          ))}
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" size="sm" className="border" onClick={onClose}>
          Chiudi
        </Button>
        <Button
          disabled={!selectedDuration}
          variant="success"
          size="sm"
          onClick={handleSubmit}
        >
          <span>Seleziona</span>
        </Button>
      </Modal.Footer>
    </>
  );
}
